// extracted by mini-css-extract-plugin
module.exports = {"latest-approvals":"Latest_latest-approvals__1eG1m"};